function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { getFormattedDate } from '../utils';
// 스타일 컴포넌트 불러오기
import { CompactPostContainer, CompactContentWrapper, CompactHeader, UserName, VerifiedBadge, UserID, Timestamp, ContentText, MediaContainer, AvatarContainer } from '../styles/socialpost.styles';
/**
 * 컴팩트 모드의 소셜 포스트 컴포넌트
 */ var SocialPostCompact = function(param) {
    var id = param.id, content = param.content, author = param.author, _param_createdAt = param.createdAt, createdAt = _param_createdAt === void 0 ? new Date() : _param_createdAt, _param_images = param.images, images = _param_images === void 0 ? [] : _param_images, _param_videos = param.videos, videos = _param_videos === void 0 ? [] : _param_videos, linkPreview = param.linkPreview, quotedContent = param.quotedContent, poll = param.poll, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, viewTrackerRef = param.viewTrackerRef, handleCompactClick = param.handleCompactClick;
    // onVote 핸들러 추출
    var pollOnVote = poll && 'onVote' in poll ? poll.onVote : undefined;
    // 표시할 게시물 데이터
    var displayPost = {
        id: id,
        content: content || '',
        author: author,
        createdAt: createdAt,
        images: images || [],
        videos: videos || [],
        linkPreview: linkPreview,
        quotedContent: quotedContent,
        poll: poll,
        pollOnVote: pollOnVote
    };
    return /*#__PURE__*/ React.createElement(CompactPostContainer, {
        onClick: handleCompactClick,
        className: className,
        ref: viewTrackerRef
    }, /*#__PURE__*/ React.createElement(AvatarContainer, null, /*#__PURE__*/ React.createElement(Avatar, {
        username: displayPost.author.username,
        profileImage: displayPost.author.profileImage,
        name: displayPost.author.name,
        size: "md",
        alt: "".concat(displayPost.author.name, "의 프로필")
    })), /*#__PURE__*/ React.createElement(CompactContentWrapper, null, /*#__PURE__*/ React.createElement(CompactHeader, null, /*#__PURE__*/ React.createElement(UserName, null, displayPost.author.name), displayPost.author.verified && /*#__PURE__*/ React.createElement(VerifiedBadge, null, "✓"), /*#__PURE__*/ React.createElement(UserID, null, "@", displayPost.author.username), createdAt && /*#__PURE__*/ React.createElement(Timestamp, null, getFormattedDate(_instanceof(displayPost.createdAt, Date) ? displayPost.createdAt : new Date(displayPost.createdAt)))), /*#__PURE__*/ React.createElement(ContentText, null, displayPost.content), /*#__PURE__*/ React.createElement(MediaContainer, null, /*#__PURE__*/ React.createElement(ContentBase, {
        content: "",
        images: displayPost.images,
        videos: displayPost.videos,
        linkPreview: linkPreview,
        quotedContent: quotedContent ? _object_spread_props(_object_spread({}, quotedContent), {
            author: _object_spread_props(_object_spread({}, quotedContent.author), {
                profileImage: quotedContent.author.profileImage || ''
            })
        }) : undefined,
        poll: displayPost.poll,
        onVote: displayPost.pollOnVote
    }))));
};
export default SocialPostCompact;
